import React from 'react';
import { displayName } from '../../../App';
import MainGuidanceLayout from '../../components/Layout/Main';
import Content from '../../components/Pages/Profile';

function Profile() {
  document.title = `${displayName}: Profile`;

  return (
    <MainGuidanceLayout>
      <Content />
    </MainGuidanceLayout>
  );
}

export default Profile;
